import $ from "jquery";

const mainNav = () => {
  const hideClass = (classToRemove) => {
    $("." + classToRemove).removeClass(classToRemove);
  }
  //Menu Toggle
  var $toggle = $("#menuToggle");
  var $menu = $("#mainNav");
  $toggle.on('click', (e) => {
    e.preventDefault();
    toggleNav()
  });

  $(".nav-background").on('click', (e)=>{
    e.preventDefault();
    closeNav();
  })

  const toggleNav = () => {
    $menu.toggleClass("is-open");
    $toggle.toggleClass("is-open");
  }

  const closeNav = () => {
    $menu.removeClass('is-open');
    $toggle.removeClass('is-open');
  }


  jQuery("#mainNav .menu-item-has-children").click(function (e) {
    var clicked = jQuery(e.target);
    var parent = clicked.closest(".menu-item.menu-item-has-children");

    if (parent.hasClass("sub-open")) {
      parent.removeClass("sub-open");
      jQuery(document).off("click", function () {
        hideClass("sub-open");
      });
    } else {
      e.preventDefault();
      hideClass("sub-open");
      parent.addClass("sub-open");
      e.stopPropagation();
      jQuery(document).on("click", function () {
        hideClass("sub-open");
      });
    }
  });
  
  $(window).on('resize', (e)=>{
    closeNav();
  })
}

export default mainNav
